/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STEPINDICATOR : STEP : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	step: {
		background: theme.color.light.light.swatch,
		borderRight: replacePXinStringWithEM(`1px solid ${theme.color.neutral.light.swatch}`),
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: pxToEm(50),
		transition: theme.animation.general('all'),
		position: 'relative',
		whiteSpace: 'nowrap',

		// ..... DESC ..... //
		'& .desc': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: replacePXinStringWithEM(`0px 40px`),
			// icons
			'& .icon': {
				display: 'none',
				color: theme.color.secondary.medium.swatch,
				marginRight: pxToEm(10),
			},
			// text
			'& .text': {
				color: theme.color.neutral.medium.swatch,
				fontSize: pxToEm(16),
				fontWeight: 'normal',
				whiteSpace: 'nowrap',
				transition: 'color .2s linear 0s'
			}
		},

		// ..... LOADER ..... //
		'& .loader': {
            display: 'none',
            fontSize: '38%',
            marginRight: pxToEm(15),
            '& div': { borderTopColor: theme.color.primary.medium.swatch }
        },

		// ..... FIRST / LAST STEP ..... //
		'&:first-child': {
			flex: '1 0 auto',
			justifyContent: 'flex-end'
		},
		'&:last-child': {
			flex: '1 0 auto',
			justifyContent: 'flex-start'
		},

		// ..... ACTIVE / INACTIVE / HOVER - STATES ..... //
		'&.active': {
			background: '#F1F9FF',
			pointerEvents: 'none',
			'& .desc': { '& .text': { color: theme.color.primary.medium.swatch } },
			'&.changeDetected-true': {
				'& .icon': {
					'&.name-edit': {
						display: 'inline-block'
					}
				}
			},
			'&.isSavingData-true': {
				'& .icon': {
					display: 'none !important'
				},
				'& .loader': {
					display: 'inline-block'
				}
			}
		},
		'&.inactive': {
			'&.changeDetected-true': {
				extend: disable
			}
		},
		'&:hover': {
			background: theme.color.secondary.xlight.swatch,
			'& .desc': { '& .text': { color: theme.color.neutral.medium.swatchExtra } }
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(740)})`]: {
		step: {
			background: 'transparent !important',
			borderRight: '0',
			padding: replacePXinStringWithEM(`15px 20px 0px 0px !important`),
			justifyContent: 'flex-start',
			height: 'auto',
			whiteSpace: 'normal',
			'& .desc': {
				padding: '0',
				'& .icon': {
					fontSize: '90%',
					marginRight: pxToEm(5)
				},
				'& .text': {
					fontSize: pxToEm(13)
				}
			},
			'&:first-child': {
				flex: '0',
				justifyContent: 'flex-start',
			},
			'&:last-child': {
				flex: '0',
				justifyContent: 'flex-start'
			}
		}
	},
	[`@media only screen and (min-width:${pxToEm(740)}) and (max-width:${pxToEm(940)})`]: {
		step: {
			'& .desc': {
				padding: replacePXinStringWithEM(`0 30px`),
				'& .text': {
					fontSize: pxToEm(15)
				}
			},
			// '&:first-child': {
			// 	paddingRight: pxToEm(0)
			// },
			// '&:last-child': {
			// 	paddingLeft: pxToEm(0)
			// }
		}
	}
});